/**
* Author: ShepHertz
* TermsConditionComponent
* showed when user click on terms and condition link in the review claim component
*/
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PolicyService } from '../policy.service';
import { environment } from 'src/environments/environment';
import { ScreensService } from '../screens.service';
@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.css']
})
export class TermsConditionComponent implements OnInit {
  @ViewChild('frame', {static: false}) iframe: ElementRef;
  constructor(private policyService: PolicyService, private _screen: ScreensService,) { }
  url = environment.terms_and_conditionUrl;

  
  

  ngOnInit() {
    const lang = this._screen.getLanguage();
    if (lang == null || lang ==  "null" || lang == 'en') {
      this.url =  environment.terms_and_conditionUrl;
    } else {
      this.url = environment.terms_and_conditionUrl_TC;
    }
    // setTimeout(() => {
    //   window.top.postMessage(document.body.scrollHeight, 'http://' + window.location.host + '/terms-condition');
    // }, 500);
    // window.addEventListener('message', (e) => {
    //   this.iframe.nativeElement.style.height = e.data + 'px';
    // } , false);
  }
}
